import Button from '#base/ui/Button.js';
import classNames from 'classnames';
import React, { useMemo } from 'react';
import { useMediaQuery } from 'react-responsive';

export const useCancel = (value, cancel, revert) => {
  const initial = useMemo(() => value, []);

  const canRevert = (initial && initial !== value) || (!initial && value);
  const isNew = !initial;

  const undo = () => {
    revert && revert(initial);
    cancel();
  };

  const commit = cancel;

  return [commit, undo, canRevert, isNew];
};

export const Cancel = ({ commit, undo, canRevert, isNew, label, disabled = false, hideButton = false }) => {
  const isMobile = useMediaQuery({ maxWidth: 767 });

  return (
    <div className='t-mt-3 t-flex t-items-center t-justify-center t-gap-1 t-text-center md:t-mt-6 lg:t-flex-col'>
      {!hideButton && (
        <Button
          size={isMobile ? 'sm' : 'base'}
          disabled={!canRevert || disabled}
          variant='primary'
          onClick={commit}
          fullWidth='all'>
          {isNew ? 'Add' : 'Update'} {label}
        </Button>
      )}

      <div
        className={classNames({
          't-w-full': hideButton,
        })}>
        <Button variant='link' size={isMobile ? 'sm' : 'base'} onClick={undo}>
          Cancel
        </Button>
      </div>
    </div>
  );
};
